module.exports = __webpack_public_path__ + "categories/icon-calendar-b29b4e25eb3b29ca1ae2537bef443d69.svg";